(function () {
  const deleteColorSchemes = (element) => {
    element.classList.forEach(className => {
      if (className.startsWith('color-background-') && className != 'color-background-overlay') {
        element.classList.remove(className);
      }
    });
  }

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector("details-modal.header__search");
    const searchModal = document.querySelector("details-modal.header__search > details");
    const allSubmenu = document.querySelectorAll(".header__submenu");
    const isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";
    const main = document.getElementById('MainContent')
		const headerSimpleMenuLinks = document.querySelectorAll('.header__submenu-simple .header__submenu-li');
    const sections = main.querySelectorAll('.shopify-section')
    const sectionFirstChildTransparent = sections[0]?.querySelector(
      '[data-header-transparent]'
    )
    const headerTransparent = header
    .querySelector('.header-wrapper')
    .classList.contains('header-wrapper--full-width')
    
    if (isLightLogo == 'true')
			header.classList.add('header--light-logo');
    else
      header.classList.remove('header--light-logo');

    if (!(sectionFirstChildTransparent && headerTransparent)) {
      deleteColorSchemes(header);
      header.classList.remove("color-background-overlay");
    }

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search?.isOpen) {
        search.close();
      }
    });

    /*const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty("--ann-height", `${entry.boundingClientRect.height}px`);
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });

    if (annBar) {
      annBarObserver.observe(annBar);
    } else {
      document.documentElement.style.setProperty("--ann-height", `0px`);
    }*/

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				headerSimpleMenuLinks.forEach((el) => {
					if (el === e.target) {
						el.querySelector('.header__submenu').classList.add('show-submenu');
						el.querySelector('.header__submenu').classList.remove('remove-submenu');
					} else {
						el.querySelector('.header__submenu').classList.remove('show-submenu');
						el.querySelector('.header__submenu').classList.add('remove-submenu');
					}

				})
			})
		})

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");
          document.querySelector('.header__overlay').classList.add('active');

          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
              //document.querySelector('.header__overlay').classList.remove('active');
            }
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        } else {
          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            el.classList.remove("list-menu--megamenu-visible");
            document.querySelector('.header__overlay').classList.remove('active');
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        }
      });
    });

    document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

    allSubmenu.forEach((submenu) => {
      const links = submenu.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");

      links.forEach((link) => {
        const childLinks = link.parentElement.querySelectorAll(".header__submenu-item--grandchild");

        link.addEventListener("mouseenter", (e) => {
          links.forEach((el) => {
            el.classList.add("header__submenu-item--inactive");
          });
          link.classList.remove("header__submenu-item--inactive");
        });

        childLinks.forEach((childLink) => {
          childLink.addEventListener("mouseenter", (e) => {
            childLinks.forEach((el) => {
              el.classList.add("header__submenu-item--inactive");
            });
            childLink.classList.remove("header__submenu-item--inactive");
          });
        });

        link.addEventListener("mouseleave", (e) => {
          childLinks.forEach((el) => {
            el.classList.remove("header__submenu-item--inactive");
          });
        });
      });

      submenu.addEventListener("mouseleave", (e) => {
        links.forEach((el) => {
          el.classList.remove("header__submenu-item--inactive");
        });
      });
    });

    menu?.addEventListener("mouseleave", (e) => {
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-item--inactive");
        link.classList.remove("list-menu-item--active");
        link.classList.remove("list-menu--megamenu-visible");
        document.querySelector('.header__overlay').classList.remove('active');
      });

      document.querySelectorAll(".header__submenu-item").forEach((link) => {
        link.classList.remove("header__submenu-item--inactive");
      })
    });

    if (header && header.classList.contains("color-background-overlay")) {
      const colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
      header.addEventListener("mouseenter", () => {
        header.classList.remove("color-background-overlay");
        /*if (colorScheme)
          header.classList.remove(colorScheme);*/
        deleteColorSchemes(header);
        header.classList.add("color-background-overlay-hidden");
      });

      header.addEventListener("mouseleave", () => { 
        if (!searchModal?.hasAttribute("open")) {
          if (!header.classList.contains('shopify-section-header-sticky') 
            && !header.classList.contains('shopify-section-header-scroll')
            && !header.querySelector('.menu-drawer-container').classList.contains('menu-opening')
          ) {
            const main = document.getElementById('MainContent')
            const sections = main.querySelectorAll('.shopify-section')
            const sectionFirstChildTransparent = sections[0].querySelector(
              '[data-header-transparent]'
            )
            const headerTransparent = header
            .querySelector('.header-wrapper')
            .classList.contains('header-wrapper--full-width')
            
            if (sectionFirstChildTransparent && headerTransparent) {
              header.classList.add("color-background-overlay");
              if (colorScheme)
                header.classList.add(colorScheme);
            }
            header.classList.remove("color-background-overlay-hidden");
          }
        }
      });
    }

    const buttons = header.querySelectorAll('.js-open-list-menu-item')

		buttons.forEach((button) => {
			button.addEventListener('click', (event) => {
				const submenu = event.currentTarget.closest('.header__submenu')
				const items = submenu.querySelectorAll('.header__submenu-li')

				items.forEach((item) => {
					item.classList.add('active')
				})

				event.currentTarget.parentElement.classList.add('hide')
			})
		})
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();

/* ZinVolt header: lichte, toegankelijke dropdownbediening. */
(() => {
  'use strict';

  if (window.__zvHeaderEnhancementsReady) return;
  window.__zvHeaderEnhancementsReady = true;

  const headerSelector = '.shopify-section-header';
  const dropdownItemSelector = '.zv-header__dropdown-item';
  const dropdownTriggerSelector = '.zv-header__dropdown-trigger';
  const megaItemSelector = '.list-menu--megamenu';
  const megaTriggerSelector = '.zv-header__mega-trigger';
  const finePointerQuery = '(hover: hover) and (pointer: fine)';
  const suppressedFocusItems = new WeakSet();

  const hasFinePointer = () => window.matchMedia(finePointerQuery).matches;

  const setDropdownState = (item, expanded) => {
    if (!item) return;
    const trigger = item.querySelector(`:scope > ${dropdownTriggerSelector}`);
    item.classList.toggle('is-open', expanded);
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const closeOtherDropdowns = (header, activeItem = null) => {
    if (!header) return;
    header.querySelectorAll(dropdownItemSelector).forEach((item) => {
      if (item !== activeItem) setDropdownState(item, false);
    });
  };

  const setMegaState = (item, expanded) => {
    if (!item) return;
    const trigger = item.querySelector(`:scope > ${megaTriggerSelector}`);
    item.classList.toggle('list-menu--megamenu-visible', expanded);
    item.classList.toggle('list-menu-item--active', expanded);
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const closeOtherMegaMenus = (header, activeItem = null) => {
    if (!header) return;
    header.querySelectorAll(megaItemSelector).forEach((item) => {
      if (item !== activeItem) setMegaState(item, false);
    });
  };

  const closeAllMenus = (header) => {
    closeOtherDropdowns(header);
    closeOtherMegaMenus(header);
  };

  const initializeHeaderInteractions = (header) => {
    if (!header || header.dataset.zvHeaderInteractionsReady === 'true') return;

    header.addEventListener('pointerover', (event) => {
      if (!hasFinePointer()) return;
      const item = event.target.closest(dropdownItemSelector);
      if (!item || !header.contains(item) || item.contains(event.relatedTarget)) return;
      closeOtherDropdowns(header, item);
      setDropdownState(item, true);
    });

    header.addEventListener('pointerout', (event) => {
      if (!hasFinePointer()) return;
      const item = event.target.closest(dropdownItemSelector);
      if (!item || !header.contains(item) || item.contains(event.relatedTarget)) return;
      setDropdownState(item, false);
    });

    header.addEventListener('focusin', (event) => {
      if (!hasFinePointer()) return;
      const item = event.target.closest(dropdownItemSelector);
      if (!item || !header.contains(item)) return;
      if (suppressedFocusItems.has(item)) {
        suppressedFocusItems.delete(item);
        return;
      }
      closeOtherDropdowns(header, item);
      setDropdownState(item, true);
    });

    header.addEventListener('focusout', (event) => {
      if (!hasFinePointer()) return;
      const item = event.target.closest(dropdownItemSelector);
      if (!item || !header.contains(item)) return;
      window.requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) setDropdownState(item, false);
      });
    });

    header.addEventListener('click', (event) => {
      const trigger = event.target.closest(dropdownTriggerSelector);
      const megaTrigger = event.target.closest(megaTriggerSelector);

      if (megaTrigger && header.contains(megaTrigger)) {
        const item = megaTrigger.closest(megaItemSelector);

        if (!hasFinePointer() && !item.classList.contains('list-menu--megamenu-visible')) {
          event.preventDefault();
          closeOtherDropdowns(header);
          closeOtherMegaMenus(header, item);
          setMegaState(item, true);
        }
        return;
      }

      if (!trigger || !header.contains(trigger)) return;

      const item = trigger.closest(dropdownItemSelector);
      closeOtherMegaMenus(header);
      closeOtherDropdowns(header, item);
      setDropdownState(item, hasFinePointer() ? true : !item.classList.contains('is-open'));
    });

    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const item = event.target.closest(dropdownItemSelector)
        || header.querySelector(`${dropdownItemSelector}.is-open`);
      const megaItem = event.target.closest(megaItemSelector)
        || header.querySelector(`${megaItemSelector}.list-menu--megamenu-visible`);
      const activeItem = item || megaItem;
      if (!activeItem) return;

      event.preventDefault();
      closeAllMenus(header);
      const trigger = activeItem.querySelector(`:scope > ${dropdownTriggerSelector}, :scope > ${megaTriggerSelector}`);
      if (trigger && document.activeElement !== trigger) {
        if (item) suppressedFocusItems.add(item);
        trigger.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!header.contains(event.target)) closeAllMenus(header);
    });

    header.dataset.zvHeaderInteractionsReady = 'true';
  };

  const initialize = (scope = document) => {
    const header = scope.matches?.(headerSelector)
      ? scope
      : scope.querySelector?.(headerSelector) || document.querySelector(headerSelector);
    initializeHeaderInteractions(header);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
